import {useCallback} from 'react';

import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {AiEmailTemplateGenerateFromTemplateInput} from 'nutshell-graphql-types';

import GENERATE_AI_EMAIL_FROM_TEMPLATE from '../mutations/generate-ai-email-from-template.graphql';
import GET_AI_GENERATED_TEMPLATE_BY_EDITION from '../queries/get-ai-generated-template-by-edition.graphql';

export const useGenerateAiEmailFromTemplate = (): {
    generateAiEmailFromTemplate: (input: AiEmailTemplateGenerateFromTemplateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [generateAiEmailFromTemplate, {loading, error}] = useMutation(
        GENERATE_AI_EMAIL_FROM_TEMPLATE
    );

    const generateAiEmailFromTemplateMutation = useCallback(
        async (input: AiEmailTemplateGenerateFromTemplateInput) => {
            return generateAiEmailFromTemplate({
                variables: {input},
                update: (_cache, {data}) => {
                    if (!data) return;

                    const aiGeneratedTemplate = data.aiEmailTemplateGenerateFromTemplate.campaign;

                    for (const edition of aiGeneratedTemplate.editions.edges) {
                        _cache.writeQuery({
                            query: GET_AI_GENERATED_TEMPLATE_BY_EDITION,
                            variables: {editionId: edition.node.id},
                            data: {
                                aiGeneratedTemplateGet: aiGeneratedTemplate,
                            },
                        });
                    }
                },
            });
        },
        [generateAiEmailFromTemplate]
    );

    return {
        generateAiEmailFromTemplate: generateAiEmailFromTemplateMutation,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
